import ContractsCargoTaxiListRequest, {
  ContractsCargoTaxiListRequestQueryParams,
} from "./contracts-cargo-taxi-list-request";

const createQueryParams = (
  data: ContractsCargoTaxiListRequest,
): ContractsCargoTaxiListRequestQueryParams => {
  return {
    active: data.active,
    cargoCompanyName: data.cargoCompanyName,
    limit: data.limit,
    offset: data.offset,
    order: data.order,
    taxiCorporationName: data.taxiCorporationName,
  };
};

const contractsCargoTaxiListRequestFactory = { createQueryParams };

export default contractsCargoTaxiListRequestFactory;
